// Role labels and default landing paths.
// Roles identify account type only; module access is checked with direct permissions.

export const ROLES = {
  superadmin: { label: 'Gestor do Sistema' },
  admin: { label: 'Gestor Master' },
  gestor: { label: 'Gestor' },
  condutor: { label: 'Utilizador' },
};

export const DEFAULT_PATH_FOR_ROLE = {
  superadmin: '/account',
  admin: '/',
  gestor: '/',
  condutor: '/',
};
